var render = function render(){var _vm=this,_c=_vm._self._c;return _c('campaigns-base',{attrs:{"variant":"smart-tooltips"}})
}
var staticRenderFns = []

export { render, staticRenderFns }